import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["monthlyPrice", "annualPrice", "monthlyLabel", "annualLabel", "savingsBadge", "checkoutLink"]
  static values = { interval: String }

  connect() {
    if (!this.intervalValue) {
      this.intervalValue = "annual"
    }
    this.updateDisplay()
  }

  selectInterval(event) {
    event.preventDefault()
    const interval = event.currentTarget.dataset.interval
    if (interval && interval !== this.intervalValue) {
      this.intervalValue = interval
    }
  }

  intervalValueChanged() {
    this.updateDisplay()
  }

  updateDisplay() {
    const isAnnual = this.intervalValue === "annual"

    // Update label active states
    this.monthlyLabelTargets.forEach(el => {
      el.classList.toggle("active", !isAnnual)
    })

    this.annualLabelTargets.forEach(el => {
      el.classList.toggle("active", isAnnual)
    })

    // Show/hide price elements
    this.monthlyPriceTargets.forEach(el => {
      el.classList.toggle("d-none", isAnnual)
    })

    this.annualPriceTargets.forEach(el => {
      el.classList.toggle("d-none", !isAnnual)
    })

    // Show savings badge only for annual
    this.savingsBadgeTargets.forEach(el => {
      el.style.visibility = isAnnual ? "visible" : "hidden"
    })

    // Update checkout links
    this.checkoutLinkTargets.forEach(el => {
      const monthlyUrl = el.dataset.monthlyUrl
      const annualUrl = el.dataset.annualUrl
      if (monthlyUrl && annualUrl) {
        el.href = isAnnual ? annualUrl : monthlyUrl
      }
    })
  }
}
